var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-qr-code",style:(_vm.wrapperStyle)},[_c('div',{ref:"qrcode"}),(_vm.logoSrc)?_c('img',{style:(_vm.logoStyle),attrs:{"src":_vm.logoSrc,"alt":"qrcode-logo"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }